import type { RouteAuthMode } from "../../shared/monitoringRouteAuth";
import type { StatusBadgeColor } from "../components/StatusBadge";

const ROUTE_AUTH_LABELS: Record<RouteAuthMode, string> = {
  public: "Public",
  external_id: "External ID",
  tenant: "Tenant",
  sso: "SSO",
  connected_app: "Connector",
  space: "Space",
};

export const ROUTE_AUTH_COLORS: Record<RouteAuthMode, string> = {
  public: "var(--red-600)",
  external_id: "var(--yellow-600)",
  tenant: "var(--sky-600)",
  sso: "var(--purple-600)",
  connected_app: "var(--teal-600)",
  space: "var(--green-600)",
};

// Gallery-badge colors. Unlike ROUTE_AUTH_COLORS (a distinct hue per mode, for
// the monitoring charts), the badge deliberately mutes every scope to grey
// except the two that need no sign-in (public, external_id), so the exposed
// links stand out at a glance.
export const ROUTE_AUTH_BADGE_COLORS: Record<RouteAuthMode, StatusBadgeColor> =
  {
    public: "red",
    external_id: "yellow",
    tenant: "gray",
    sso: "gray",
    connected_app: "gray",
    space: "gray",
  };

const ROUTE_AUTH_DESCRIPTIONS: Record<RouteAuthMode, string> = {
  public: "Anyone on the internet. No sign-in required.",
  external_id: "Anyone who has the link. No sign-in required.",
  tenant: "Anyone signed in to your tenant.",
  sso: "Anyone who can sign in through your SSO provider.",
  connected_app: "Other workflows in your tenant, through a connector.",
  space: "Only members of the workflow’s space.",
};

export function routeAuthLabel(
  mode: RouteAuthMode,
  groups: readonly string[] = []
): string {
  const label = ROUTE_AUTH_LABELS[mode];
  return groups.length ? `${label} · ${groups.join(", ")}` : label;
}

export function routeAuthDescription(
  mode: RouteAuthMode,
  groups: readonly string[] = []
): string {
  const description = ROUTE_AUTH_DESCRIPTIONS[mode];
  return groups.length
    ? `${description} Limited to members of ${groups.join(", ")}.`
    : description;
}
